var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import i18next from '../../strings/i18n/i18n';
import { AlertAttributeTypes } from '../../typings/enums';
import { AlertIDType, SELECT_FIELD_DEFAULT_VALUE, TEXT_FIELD_DEFAULT_VALUE } from '../../const/alertsConfig';
export var isValidCurrencyInput = function (value) {
    var tmpInputValue = value === null || value === void 0 ? void 0 : value.toString();
    var pattern = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{0,})?$/;
    return pattern.test(tmpInputValue);
};
export var replaceDecimals = function (value) {
    var tmpInputValue = value === null || value === void 0 ? void 0 : value.toString();
    var integerPart = tmpInputValue === null || tmpInputValue === void 0 ? void 0 : tmpInputValue.split('.')[0];
    tmpInputValue = "".concat(integerPart, ".00");
    return tmpInputValue;
};
// Value string will be formatted correctly i.e. 1,000.00 instead of 1000
export var formatToCurrency = function (value) {
    var tmpInputValue = value === null || value === void 0 ? void 0 : value.toString();
    tmpInputValue = tmpInputValue === null || tmpInputValue === void 0 ? void 0 : tmpInputValue.replace(/,/g, '');
    tmpInputValue = tmpInputValue === null || tmpInputValue === void 0 ? void 0 : tmpInputValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return tmpInputValue;
};
export var removeLeadingZeros = function (value) {
    var newInputValue = value === null || value === void 0 ? void 0 : value.toString();
    return newInputValue === null || newInputValue === void 0 ? void 0 : newInputValue.replace(/^0+/, '');
};
export var cleanInputValue = function (inputValue) {
    var newInputValue = inputValue;
    // Removing all , from the string
    newInputValue = newInputValue === null || newInputValue === void 0 ? void 0 : newInputValue.replace(/,/g, '');
    /*
     * Replacing any decimals .85 with .00
     * removing decimals and send whole values
     */
    newInputValue = (newInputValue === null || newInputValue === void 0 ? void 0 : newInputValue.includes('.'))
        ? newInputValue === null || newInputValue === void 0 ? void 0 : newInputValue.split('.')[0]
        : "".concat(newInputValue);
    return newInputValue;
};
export var handleTurnOffAttributeValue = function (value, key, defaultAttributeMetaValue) {
    switch (key) {
        case AlertAttributeTypes.ReminderDueDays:
        case AlertAttributeTypes.PromoExpiryDays:
            return defaultAttributeMetaValue || SELECT_FIELD_DEFAULT_VALUE;
        case AlertAttributeTypes.AvailableCreditThresholdAmount:
        case AlertAttributeTypes.BalanceExceedsThresholdAmount:
        case AlertAttributeTypes.PurchaseExceedsThresholdAmount:
            return defaultAttributeMetaValue || TEXT_FIELD_DEFAULT_VALUE;
        case AlertAttributeTypes.ApprovedTransactionType:
        case AlertAttributeTypes.GenerousTipPercentage:
            return defaultAttributeMetaValue || '';
        default:
            return value;
    }
};
export var formatAttributeValueForForm = function (value, key) {
    switch (key) {
        case AlertAttributeTypes.ReminderDueDays:
        case AlertAttributeTypes.PromoExpiryDays:
            return value;
        case AlertAttributeTypes.AvailableCreditThresholdAmount:
        case AlertAttributeTypes.BalanceExceedsThresholdAmount:
        case AlertAttributeTypes.PurchaseExceedsThresholdAmount:
            return parseFloat(value) < 1
                ? ''
                : formatToCurrency(removeLeadingZeros(replaceDecimals(value)));
        case AlertAttributeTypes.GenerousTipPercentage:
            return parseFloat(value) < 1 ? '' : value;
        default:
            return value;
    }
};
export var formatAttributesForForm = function (attributes) {
    var formattedAttributes = {};
    Object.keys(attributes).forEach(function (key) {
        var _a;
        formattedAttributes[key] = {
            value: formatAttributeValueForForm((_a = attributes[key]) === null || _a === void 0 ? void 0 : _a.value, key)
        };
    });
    return formattedAttributes;
};
export var formatAttributeValueForApi = function (value, key) {
    switch (key) {
        case AlertAttributeTypes.ReminderDueDays:
        case AlertAttributeTypes.PromoExpiryDays:
            return value;
        case AlertAttributeTypes.AvailableCreditThresholdAmount:
        case AlertAttributeTypes.BalanceExceedsThresholdAmount:
        case AlertAttributeTypes.PurchaseExceedsThresholdAmount:
            return cleanInputValue(value);
        default:
            return value;
    }
};
export var getResetAttributes = function (alertData) {
    return alertData.attributes.reduce(function (prev, curr) {
        var _a;
        return (__assign(__assign({}, prev), (_a = {}, _a[curr.key] = {
            value: curr === null || curr === void 0 ? void 0 : curr.value
        }, _a)));
    }, {});
};
export var getResetDelivery = function (alertData) {
    return alertData.allDeliveryMethods.reduce(function (prev, curr) {
        var _a;
        return (__assign(__assign({}, prev), (_a = {}, _a[curr.key] = {
            enrolled: curr.enrolled
        }, _a)));
    }, {});
};
export var isAttributeValueValid = function (value, key, allAlertsFormData) {
    switch (key) {
        case AlertAttributeTypes.ReminderDueDays:
        case AlertAttributeTypes.PromoExpiryDays:
            return value !== '';
        case AlertAttributeTypes.AvailableCreditThresholdAmount:
        case AlertAttributeTypes.BalanceExceedsThresholdAmount:
        case AlertAttributeTypes.PurchaseExceedsThresholdAmount:
            return isValidCurrencyInput(value);
        case AlertAttributeTypes.ApprovedTransactionType:
            if (value === '') {
                return false;
            }
            if (value === AlertIDType.PURCHASE_EXCEEDS) {
                return isValidCurrencyInput(allAlertsFormData.PURCHASE_EXCEEDS.attributes
                    .purchaseExceedsThresholdAmount.value);
            }
            return true;
        case AlertAttributeTypes.GenerousTipPercentage: {
            var numVal = +value;
            return !(Number.isNaN(numVal) ||
                numVal % 1 !== 0 ||
                numVal < 1 ||
                numVal > 200);
        }
        default:
            return true;
    }
};
export var getAttributeError = function (key) {
    var errorKey;
    switch (key) {
        case AlertAttributeTypes.ReminderDueDays:
        case AlertAttributeTypes.PromoExpiryDays:
        case AlertAttributeTypes.AvailableCreditThresholdAmount:
        case AlertAttributeTypes.BalanceExceedsThresholdAmount:
        case AlertAttributeTypes.PurchaseExceedsThresholdAmount:
            errorKey = 'amountTextField';
            break;
        case AlertAttributeTypes.ApprovedTransactionType:
            errorKey = 'approvedTrnxType';
            break;
        case AlertAttributeTypes.GenerousTipPercentage:
            errorKey = 'percentageTextField';
            break;
        default:
            return null;
    }
    return {
        key: key,
        value: i18next.t("errorMessages.".concat(errorKey))
    };
};
export var validateFormData = function (alertFormData, currentAlertData, allAlertsFormData) {
    var attributes = alertFormData.attributes, delivery = alertFormData.delivery;
    var errors = [];
    if (attributes) {
        Object.keys(attributes).forEach(function (attKey) {
            var value = attributes[attKey].value;
            if (!isAttributeValueValid(value, attKey, allAlertsFormData)) {
                errors.push(getAttributeError(attKey));
            }
        });
    }
    var validDelivery = currentAlertData.allDeliveryMethods.some(function (delivMethod) { return delivery[delivMethod.key].enrolled; });
    if (!validDelivery) {
        errors.push({
            key: 'delivery',
            value: i18next.t('errorMessages.deliveryMethod')
        });
    }
    return errors;
};
export var getFormIsDirty = function (formAttributes, formDelivery, currentAlertData) {
    var deliveryHasChanged = currentAlertData.allDeliveryMethods.some(function (delMethod) { var _a; return delMethod.enrolled !== ((_a = formDelivery[delMethod.key]) === null || _a === void 0 ? void 0 : _a.enrolled); });
    // added to handle approved transactions
    var isApprovedTransactions = currentAlertData.id === AlertIDType.APPROVED_TRANSACTIONS;
    var attributeHasChanged = currentAlertData.attributes.some(function (attr) {
        var _a, _b, _c, _d;
        if (isApprovedTransactions) {
            return attr.value !== ((_a = formAttributes[attr.key]) === null || _a === void 0 ? void 0 : _a.value);
        }
        return (parseFloat((_b = attr === null || attr === void 0 ? void 0 : attr.value) === null || _b === void 0 ? void 0 : _b.replace(/,/g, '')) !==
            parseFloat((_d = (_c = formAttributes[attr.key]) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.replace(/,/g, '')));
    });
    return deliveryHasChanged || attributeHasChanged;
};
export var turnOffAllDeliveries = function (deliveries) {
    return Object.keys(deliveries).reduce(function (acc, delivery) {
        acc[delivery] = {
            enrolled: false
        };
        return acc;
    }, {});
};
export var turnOffAllAttributes = function (attributes) {
    return Object.keys(attributes).reduce(function (prev, attributeKey) {
        var _a;
        var _b;
        return __assign(__assign({}, prev), (_a = {}, _a[attributeKey] = {
            value: handleTurnOffAttributeValue((_b = attributes[attributeKey]) === null || _b === void 0 ? void 0 : _b.value, attributeKey)
        }, _a));
    }, {});
};
export var turnOffAllAlertDataAttributes = function (attributes) {
    return attributes.reduce(function (prev, curr) {
        var _a;
        return __assign(__assign({}, prev), (_a = {}, _a[curr.key] = {
            value: handleTurnOffAttributeValue(curr === null || curr === void 0 ? void 0 : curr.value, curr.key)
        }, _a));
    }, {});
};
export var turnOffAllAlertDataDeliveries = function (allDeliveryMethods) {
    return allDeliveryMethods.reduce(function (prev, curr) {
        var _a;
        return __assign(__assign({}, prev), (_a = {}, _a[curr.key] = {
            // if not enabled don't change the enrolled value
            enrolled: curr.enrolled ? false : curr.enrolled
        }, _a));
    }, {});
};
export var formatAttributesForApi = function (attributes) {
    return Object.keys(attributes || {}).reduce(function (prev, currKey) {
        var _a;
        var _b;
        var attributeValue = (_b = attributes[currKey]) === null || _b === void 0 ? void 0 : _b.value;
        return __assign(__assign({}, prev), (_a = {}, _a[currKey] = {
            value: formatAttributeValueForApi(attributeValue, currKey)
        }, _a));
    }, {});
};
